import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useTranslation } from 'react-i18next';

const LoginHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBackClick = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/home-page');
    }
  };

  return (
    <div className="flex items-center justify-between mb-8 px-4 sm:px-0">
      {/* Back Button */}
      <Button
        variant="ghost"
        size="sm"
        onClick={handleBackClick}
        iconName="ArrowLeft"
        iconPosition="left"
        className="text-gray-500 hover:text-gray-900 transition-colors duration-200"
      >
        <span className="hidden sm:inline">{t("back")}</span>
      </Button>

      {/* Logo */}
      <Link
        to="/home-page"
        className="flex items-center space-x-3 hover:opacity-80 transition-opacity duration-200"
      >
        <div className="w-14 h-14 rounded-lg overflow-hidden shadow-md">
          <img
            src="/assets/images/logo.png"
            alt="logo"
            className="w-full h-full object-cover"
          />
        </div>
      </Link>

      {/* Help Link */}
      <Link
        to="/support"
        className="flex items-center space-x-1 text-sm text-gray-500 hover:text-indigo-600 transition-colors duration-200"
      >
        <Icon name="HelpCircle" size={18} />
        <span className="hidden sm:inline">{t("help")}</span>
      </Link>
    </div>
  );
};

export default LoginHeader;
